import { FunctionComponent } from 'react';
import { NavLink } from 'react-router';
import { NavigationItemId, useSubNavigationItems } from './navigationItems';
import SubNavigation from './SubNavigation';

type Props = {
    parentId: NavigationItemId;
};

const SubMenu: FunctionComponent<Props> = ({ parentId }) => {
    const { items, heading } = useSubNavigationItems(parentId);

    if (items.length === 0) {
        return null;
    }

    return (
        <SubNavigation heading={heading}>
            <div className="submenu__content">
                <div className="submenu__links">
                    {items.map((item) => (
                        <NavLink key={item.id} to={item.path} end={item.end} className="submenu__link">
                            {item.label}
                        </NavLink>
                    ))}
                </div>
            </div>
        </SubNavigation>
    );
};

export default SubMenu;
